import React, { useState, useContext, useEffect, Fragment, useRef } from "react";
import {
	Link,
	useParams,
	useNavigate
} from "react-router-dom";
import Swal from "sweetalert2";
import { useHotkeys } from "react-hotkeys-hook";

//Contexto
import ConexContext from "../context/conex/ConexContext";

//SVG
import { ReactComponent as WriteIcon } from "../assets/img/iconos/acae_edit_1.svg";
import { ReactComponent as TrashIcon } from "../assets/img/iconos/acae_trash.svg";
import { ReactComponent as CursoIcon } from "../assets/img/iconos/acae_course.svg";
import { ReactComponent as ValidarIcon } from "../assets/img/iconos/acae_check.svg";
import { ReactComponent as QuitarIcon } from "../assets/img/iconos/acae_close.svg";
import { ReactComponent as MasIcon } from "../assets/img/iconos/acae_add.svg";
import { ReactComponent as AcaeIcon } from "../assets/img/iconos/acae_flower_fill.svg";
import { ReactComponent as AcaeArrow } from "../assets/img/iconos/acae_arrow.svg";
import { ReactComponent as ViewIcon } from "../assets/img/iconos/acae_view.svg";
import { ReactComponent as SettingsIcon } from "../assets/img/iconos/acae_settings.svg";
import { ReactComponent as EditIcon } from "../assets/img/iconos/acae_edit_2.svg";
import { ReactComponent as OptionsIcon } from "../assets/img/iconos/acae_options.svg";


//imagenes
import mas from "../assets/img/iconos/acae_add.svg";
import desc from "../assets/img/desc.svg";
import asc from "../assets/img/asc.svg";

//modulos
import CursosMod from "./CursosMod";
import Paginacion from "./comun/Paginacion";
import InscripcionMod from "./InscripcionMod";
import MenuToggle from "./comun/menuToggle";
import FloatingMenu from "./comun/FloatingMenu";

const Cursos = ({ setSidebar, Sidebar, setTimer }) => {
	const {
		peticion,
		loc,
		perfil_admin,
		perfil_adm_asoc,
		perfil_adm_dojo,
		perfil_dojo,
		perfil_id,
		Cargando,
	} = useContext(ConexContext); //contexto
	
	const {
		idReg,
		lang
	} = useParams();

	const navigate = useNavigate();

	//STATES
	// const [Detalles, setDetalles] = useState(0)// id del que se debe mostrar detalles
	const [VerMod, setVerMod] = useState(0); // para ver el modal de Ficheros
	const [VerIns, setVerIns] = useState(0); // para ver el modal de Inscribirse
	const [List, setList] = useState([]); // listado
	const [NRes, setNRes] = useState(0); // Nº de registros con filtro
	const [NTot, setNTot] = useState(0); // Nº de registros con filtro
	const [ListParams, setListParams] = useState({
		num: 15,
		orden: "fecha DESC",
		filtro: "",
		ini: 0,
		nomAso: "",
		idAsoc: 0,
		idReg: 0,
	});

	const menuRefs = useRef({});

	const [activeMenu, setActiveMenu] = useState(null);

	const toggleMenu = (id) => {
		setActiveMenu(activeMenu === id ? null : id);
	};

	// useEffect(() => {
	// 	const handleClickOutside = (event) => {
	// 		if (!event.target.closest(".menu-wrapper")) {
	// 			setActiveMenu(null);
	// 		}
	// 	};
	// 	document.addEventListener("mousedown", handleClickOutside);
	// 	return () => {
	// 		document.removeEventListener("mousedown", handleClickOutside);
	// 	};
	// }, []);

	//atajos de teclado
	useHotkeys("alt+n", () => {
		if (perfil_admin | perfil_adm_asoc | perfil_adm_dojo) setVerMod(-1);
	});

	//borra un registro concreto
	const borrar = async (id) => {
		const pet = await peticion("/cursos/delCurso", {
			method: "POST",
			json: {
				idCurso: id,
			},
		});
		if (pet?.estado ?? 0 === 9) {
			Swal.fire({
				title: loc("El curso no se puede eliminar."),
				text: loc("Ha habido un error al intentar eliminar el curso"),
				showConfirmButton: true,
				icon: "error",
			});
			return;
		}
		if (pet?.estado ?? true)
			//algún error
			return;
		Swal.fire({
			title: loc("Curso eliminado."),
			showConfirmButton: false,
			icon: "success",
			timer: 1500,
		});
		setListParams({ ...ListParams });
	};

	//cambia el orden
	const orden = (campo) => {
		if (ListParams.orden === campo)
			setListParams({ ...ListParams, orden: campo + " DESC" });
		else setListParams({ ...ListParams, orden: campo });
	};

	//EFFECT
	useEffect(() => {
		const idRegN = isNaN(parseInt(idReg)) ? 0 : parseInt(idReg); // id del curso en número

		if (ListParams.idReg !== idRegN) {
			getPosicion(idRegN);
		} else {
			listar();
		}

		// eslint-disable-next-line
	}, [ListParams, idReg]);

	// Función para listar cursos
	const listar = async () => {
		const pet = await peticion(
			"/cursos/?" +
				`ini=${ListParams.ini}&` +
				`pag=${ListParams.num}&` +
				`orden=${ListParams.orden}&` +
				`filtro=${ListParams.filtro}`
		);
		if (pet?.estado ?? false)
			// algún error
			return null;
		setList(pet.res);
		setNRes(pet.nRes);
		setNTot(pet.nTot);
	};

	// Función para obtener la posición de un curso específico
	const getPosicion = async (id) => {
		const pet = await peticion('/cursos/posicion?' +
			`id=${id}&`)
		if (pet?.estado ?? false)//algún error 
			return;
		if (pet?.res?.pos ?? false) {
			setListParams((prev) => ({ ...prev, idReg: id }))
			setVerIns(id)
		}
		else navigate(`/${lang}/app/cursos`)
		
	};

	// Función para alternar la validación de un curso
	async function validarCurso(id) {
		try {
			const pet = await peticion("/cursos/cursoToggleVal", {
				method: "POST",
				json: {
					idCurso: id,
				},
			});
			if (pet?.estado ?? false) return; // algún error

			// Refresca la lista de cursos después de cambiar el estado de validación
			setTimer(0);
			listar();
		} catch (error) {
			console.error("Error al validar el curso:", error);
		}
	}

	function getCursoActions(elem) {
		const acciones = [];
	
		if (perfil_adm_dojo && perfil_dojo === elem.cfOrganiz) {
			acciones.push({
				label: loc("Gestionar"),
				icon: <SettingsIcon className="icon" />,
				onClick: () => setVerIns(elem.idCurso),
			});
		} else if (elem.cfValAdmi && elem.estado !== "Terminado") {
			acciones.push({
				label: loc("Inscribirse"),
				icon: <WriteIcon className="icon" />,
				onClick: () => setVerIns(elem.idCurso),
			});
		} else {
			acciones.push({
				label: loc("Ver"),
				icon: <ViewIcon className="icon" />,
				onClick: () => setVerIns(elem.idCurso),
			});
		}
	
		// Eliminar
		if ((perfil_adm_dojo || perfil_admin) &&
			(perfil_admin || perfil_dojo === elem.cfOrganiz) &&
			!elem.cfValAdmi) {
			acciones.push({
				label: loc("Borrar"),
				icon: <TrashIcon className="icon" />,
				onClick: () =>
					Swal.fire({
						title: loc("¿Seguro que quieres eliminar el curso?"),
						showCancelButton: true,
						confirmButtonText: loc("Sí"),
						cancelButtonText: loc("No"),
						icon: "question",
					}).then((result) => {
						if (result.isConfirmed) borrar(elem.idCurso);
					}),
			});
		}
	
		// Modificar
		if ((perfil_adm_dojo || perfil_admin) &&
			(perfil_admin || perfil_dojo === elem.cfOrganiz) &&
			!elem.cfValAdmi) {
			acciones.push({
				label: loc("Modificar"),
				icon: <EditIcon className="icon" />,
				onClick: () => setVerMod(elem.idCurso),
			});
		}
	
		// Validar / Desvalidar
		if (perfil_admin) {
			acciones.push({
				label: elem.cfValAdmi ? loc("Desvalidar") : loc("Validar"),
				icon: elem.cfValAdmi ? <QuitarIcon className="icon" /> : <ValidarIcon className="icon" />,
				onClick: () => validarCurso(elem.idCurso),
			});
		}
	
		// Ir a dojo
		if (perfil_adm_asoc || perfil_admin) {
			acciones.push({
				label: `${loc("Ir a dojo")} ${elem?.dojo}`,
				icon: <AcaeArrow className="icon" />,
				link: true,
				onClick: () => navigate(`/${lang}/app/asociados/dojo_${elem.cfOrganiz}`),
			});
		}
	
		return acciones;
	}

	const accionesPorCurso = List.reduce((acc, elem) => {
		acc[elem.idCurso] = getCursoActions(elem);
		return acc;
	}, {});

	return (
		<>
			<div className="content-wrapper main-section" id="cursos">
				<header className="backdrop space-between">
					<div className="flex-row-item">
						<CursoIcon className="section-icon" alt={loc("Cursos")} />
						<h1>{loc("Cursos")}</h1>
					</div>
					<MenuToggle Sidebar={Sidebar} setSidebar={setSidebar} />
				</header>

				{Cargando && !VerMod && !VerIns ? (
					<div className="backdrop precarga">
						<div className="loader-wrapper">
							<div className="circle-wrapper">
								<div className="circle-1" />
								<div className="circle-2" />
								<div className="circle-3" />
								<div className="circle-4" />
								<div className="circle-5" />
							</div>
							<AcaeIcon />
						</div>
						<span>
							{loc("Cargando...")}
						</span>
					</div>
				) : (
					<>
						<div className="backdrop content-wrapper">
							<div className="filtering">
								<Paginacion
									nrPag={List.length}
									NRes={NRes}
									NTot={NTot}
									Ini={ListParams.ini}
									setListParams={setListParams}
									Num={ListParams.num}
									Filtro={ListParams.filtro}
								/>
							</div>

							<div className="table-container">
								<table className="table-cursos">
									<thead className="table-headers">
										<tr>
											{Object.values(accionesPorCurso).some(a => a.length > 0) &&
												<th className="tiny-column">
												</th>
											}
											<th className="medium-column grow-column mobile-hidden">
												<button onClick={() => orden("titulo")}>
													{loc("Título")}
												</button>
												<ul className="listaordena">
													{ListParams.orden === "titulo" && (
														<li>
															<img src={asc} alt="ordena ascendente" />
														</li>
													)}
													{ListParams.orden === "titulo DESC" && (
														<li>
															<img src={desc} alt="ordena descendente" />
														</li>
													)}
												</ul>
											</th>
											<th className="large-column">
												<button onClick={() => orden("fecha")}>
													{loc("Fecha")}
												</button>
												<ul className="listaordena">
													{ListParams.orden === "fecha" && (
														<li>
															<img src={asc} alt="ordena ascendente" />
														</li>
													)}
													{ListParams.orden === "fecha DESC" && (
														<li>
															<img src={desc} alt="ordena descendente" />
														</li>
													)}
												</ul>
											</th>
											<th className="large-s-column">
												<button onClick={() => orden("ciudad")}>
													{loc("Ciudad")}
												</button>
												<ul className="listaordena">
													{ListParams.orden === "ciudad" && (
														<li>
															<img src={asc} alt="ordena ascendente" />
														</li>
													)}
													{ListParams.orden === "ciudad DESC" && (
														<li>
															<img src={desc} alt="ordena descendente" />
														</li>
													)}
												</ul>
											</th>
											<th className="large-column">
												<button onClick={() => orden("dojo")}>
													{loc("Organiza")}
												</button>
												<ul className="listaordena">
													{ListParams.orden === "dojo" && (
														<li>
															<img src={asc} alt="ordena ascendente" />
														</li>
													)}
													{ListParams.orden === "dojo DESC" && (
														<li>
															<img src={desc} alt="ordena descendente" />
														</li>
													)}
												</ul>
											</th>
											<th className="large-column">
												<button onClick={() => orden("estado")}>
													{loc("Estado")}
												</button>
												<ul className="listaordena">
													{ListParams.orden === "estado" && (
														<li>
															<img src={asc} alt="ordena ascendente" />
														</li>
													)}
													{ListParams.orden === "estado DESC" && (
														<li>
															<img src={desc} alt="ordena descendente" />
														</li>
													)}
												</ul>
											</th>
										</tr>
									</thead>
									<tbody className="table-results">
									{List.map((elem) => (
										<Fragment key={elem.idCurso}>
											<tr>
												{accionesPorCurso[elem.idCurso].length > 0 ? (
													<td className="table-button tiny-column">
														<div
															className="menu-wrapper"
															ref={(el) => (menuRefs.current[elem.idCurso] = el)}
														>
															<OptionsIcon
																onClick={() => toggleMenu(elem.idCurso)}
																className="table-button__icon black"
															/>
															{activeMenu === elem.idCurso && (
																<FloatingMenu
																	anchorRef={{ current: menuRefs.current[elem.idCurso] }}
																	onClose={() => setActiveMenu(null)}
																	id={elem.idCurso}
																>
																	{accionesPorCurso[elem.idCurso].map((accion, i) =>
																		accion.link ? (
																			<li key={i}>
																				<Link className="no-decoration" to={accion.href}>
																					{accion.icon}
																					<span>{accion.label}</span>
																				</Link>
																			</li>
																		) : (
																			<li key={i} onClick={accion.onClick}>
																				{accion.icon}
																				<span>{accion.label}</span>
																			</li>
																		)
																	)}
																</FloatingMenu>
															)}
														</div>
													</td>
												) : (
													<td className="table-button tiny-column">
														<OptionsIcon
															onClick={() => toggleMenu(elem.idCurso)}
															className="table-button__icon black disable-actions"
														/>
													</td>
												)}
													<td className="medium-column shrink-column grow-column mobile-hidden curso-titulo">
														{elem.titulo}
													</td>
													<td className="large-column">
														{new Intl.DateTimeFormat(`${lang}-${lang.toUpperCase()}`, {
															day: "numeric",
														}).format(new Date(elem.fechaIni))}{" "}
														-{" "}
														{new Intl.DateTimeFormat(`${lang}-${lang.toUpperCase()}`, {
															day: "numeric",
															month: "short",
															year: "numeric",
														})
															.format(new Date(elem.fechaFin))
															.toUpperCase()}
													</td>
													<td className="large-s-column">{elem.ciudad}</td>
													<td className="table-button black large-column">
														{elem?.dojo}
													</td>
													<td
														className={`large-column estado-wrapper ${
															elem.cfValAdmi ? "aprobado" : ""
														}`}
													>
														<div
															className={`estado-container ${
																elem.estado === "En curso"
																	? "en-curso"
																	: elem.estado === "Terminado"
																	? "terminado"
																	: ""
															}`}
														>
															{loc(elem.estado)}
														</div>
													</td>
												</tr>
											</Fragment>
										))}
									</tbody>
								</table>
							</div>
							{perfil_admin | perfil_adm_asoc | perfil_adm_dojo ? (
								<div>
									<button
										className="button primary"
										onClick={() => setVerMod(-1)}>
										{loc("Añadir nuevo curso")}
										<MasIcon src={mas} alt={loc("Más")} />
									</button>
								</div>
							) : (
								""
							)}
						</div>
						<CursosMod
							show={VerMod}
							ListParams={ListParams}
							setListParams={setListParams}
							onHide={() => setVerMod(0)}
							listar={() => listar()}
						/>
						<InscripcionMod
							show={VerIns}
							ListParams={ListParams}
							setListParams={setListParams}
							onHide={() => setVerIns(0)}
							idAsociado={perfil_id}
							caller="cursos"
						/>
					</>
				)}
			</div>
		</>
	);
};

export default Cursos;
